export const TARGET_HAS_FOOD_ERROR = "TARGET_HAS_FOOD";

export function isTargetHasFoodError(error) {
	if (!error) {
		return false;
	}
	const message =
		error instanceof Error
			? error.message
			: typeof error === "string"
				? error
				: "";
	return message.includes(TARGET_HAS_FOOD_ERROR);
}

export function errorText(error) {
	if (!error) {
		return "";
	}
	if (error instanceof Error) {
		return error.message || "";
	}
	return String(error);
}
